import { render, staticRenderFns } from "./DemoWalkthrough.vue?vue&type=template&id=3544cc7a&scoped=true&"
import script from "./DemoWalkthrough.vue?vue&type=script&lang=js&"
export * from "./DemoWalkthrough.vue?vue&type=script&lang=js&"
import style0 from "./DemoWalkthrough.vue?vue&type=style&index=0&id=3544cc7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3544cc7a",
  null
  
)

export default component.exports